import React from "react";
import { Spin } from "antd";
const Loading = ({ size }) => <Spin size={size} />;
export default Loading;
